import { render } from "./AlsoFoundKeywordTappable.vue?vue&type=template&id=3b1f3f74"
import script from "./AlsoFoundKeywordTappable.vue?vue&type=script&lang=js"
export * from "./AlsoFoundKeywordTappable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__